import React from "react";
import './input.css'
import { color } from "../../utils/themes/color";

export default function INPUT(props) {




    return (
        <input
            className="mohammad"
            type={props.type != undefined ? props.type : "text"}
            defultvalue={props.defultvalue != undefined && props.defultvalue != null ? props.defultvalue : ""}
            value={props.value != undefined && props.value != null ? props.value : undefined}
            maxLength={props.maxLength != undefined ? props.maxLength : ""}
            style={{ color: color.primary }}
            placeholder = {props.placeholder != undefined ? props.placeholder : ""}
            onChange={(e) => props.i(e.target.value)} />)


}